// Client for the AEYE public blog-feed API.
// Override the endpoint with REACT_APP_BLOG_FEED_URL if the feed key rotates.

const DEFAULT_FEED_URL =
  "https://aeye.lk/api/public/blog-feed/cmpn58xycvzx8ptrx";

export const BLOG_FEED_URL =
  process.env.REACT_APP_BLOG_FEED_URL || DEFAULT_FEED_URL;

export async function fetchBlogFeed({ page = 1, limit = 20, signal } = {}) {
  const url = new URL(BLOG_FEED_URL);
  url.searchParams.set("page", String(page));
  url.searchParams.set("limit", String(limit));

  const res = await fetch(url.toString(), { signal });
  if (!res.ok) {
    throw new Error(`Blog feed responded ${res.status}`);
  }
  const data = await res.json();
  return {
    posts: Array.isArray(data.posts) ? data.posts : [],
    total: typeof data.total === "number" ? data.total : 0,
    page: typeof data.page === "number" ? data.page : page,
    pages: typeof data.pages === "number" ? data.pages : 0,
  };
}

export function readingTime(post) {
  const words =
    typeof post.wordCount === "number"
      ? post.wordCount
      : (post.content || "").trim().split(/\s+/).filter(Boolean).length;
  if (!words) return null;
  const minutes = Math.max(1, Math.round(words / 220));
  return `${minutes} min read`;
}

export function formatPublishedAt(value) {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export function parseTags(value) {
  if (Array.isArray(value)) return value.filter(Boolean);
  if (typeof value !== "string" || !value.trim()) return [];
  try {
    const parsed = JSON.parse(value);
    if (Array.isArray(parsed)) return parsed.filter(Boolean);
  } catch {
    // Fall through to comma-splitting.
  }
  return value
    .split(",")
    .map((t) => t.trim())
    .filter(Boolean);
}
